import { apiClient } from '../../services/api';

const state = () => ({
    logs: null,
});

const getters = {
    getterLogs: state => {
        return state.logs;
    },
};

const actions = {
    async getLogs({ commit }, payload) {
        const { page, size, dsc_excecao } = payload;
        try {
            const { data } = await apiClient.get(
                `/listarLog?page=${page}&size=${size}&dsc_login_log=${dsc_excecao.toUpperCase()}`
            );
            commit('setLogs', data.logPaginado);
        } catch (error) {
            return error;
        }
    }
}

const mutations = {
    setLogs(state, payload) {
        state.logs = payload;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};